import { glyph } from './glyphs.js';

/**
 * "What do I do?": the current goal, where it is, and the one or two buttons
 * it needs, on one card, asked for with a key (Q, the d-pad's down, or the
 * pause menu) whenever a player has lost the thread.
 *
 * It does not stop the world, and it sits on the left clear of the task card
 * and the prompt, so the floor guide it points at is drawn behind it the
 * whole time it is up. It goes again on the same key, on B or Esc, or after
 * `SHOWN_FOR` seconds. What it says is handed in; it reads nothing itself.
 */
export const SHOWN_FOR = 12;

export function createHelpCard({ parent }) {
  const root = document.createElement('div');
  root.className = 'help-card';
  root.hidden = true;
  root.innerHTML = `
    <div class="help-title">What do I do?</div>
    <div class="help-goal"></div>
    <div class="help-why"></div>
    <div class="help-where"></div>
    <div class="help-buttons"></div>
    <div class="help-then"></div>
    <div class="help-foot"></div>`;
  parent.append(root);
  const part = (name) => root.querySelector(`.help-${name}`);
  let left = 0;

  function fill(state) {
    part('goal').textContent = glyph(state.goal ?? '');
    part('why').textContent = glyph(state.why ?? '');
    part('why').hidden = !state.why;
    part('where').textContent = glyph(state.where ?? '');
    part('where').hidden = !state.where;
    const buttons = part('buttons');
    buttons.replaceChildren(
      ...(state.buttons ?? []).map(([key, what]) => {
        const row = document.createElement('div');
        row.className = 'help-button';
        const k = document.createElement('span');
        k.className = 'help-key';
        k.textContent = glyph(key).replace(/^\[|\]$/g, '');
        const w = document.createElement('span');
        w.textContent = glyph(what);
        row.append(k, w);
        return row;
      })
    );
    buttons.hidden = !(state.buttons ?? []).length;
    part('then').textContent = state.then ? glyph(`Then: ${state.then}`) : '';
    part('then').hidden = !state.then;
    part('foot').textContent = glyph(state.foot ?? '');
  }

  return {
    root,
    get open() {
      return !root.hidden;
    },
    /** Puts it up with what to say, `{ goal, why, where, buttons: [[key, what]], then, foot }`. */
    show(state) {
      fill(state);
      root.hidden = false;
      left = SHOWN_FOR;
    },
    /** Keeps what it says current while it is up (the distance, the buttons). */
    refresh(state) {
      if (!root.hidden) fill(state);
    },
    hide() {
      root.hidden = true;
      left = 0;
    },
    /** Counts down; returns whether it is still up. */
    tick(dt) {
      if (root.hidden) return false;
      left -= dt;
      if (left <= 0) root.hidden = true;
      return !root.hidden;
    },
  };
}
